import * as React from "react";
import { Menu, Accordion } from "semantic-ui-react";
import "./SideMenu.less";
import useNavigation from "../hooks/UseNavigation";
import useRights from "../hooks/UseRights";
import { renderMenu } from "../context/NavigationContext";
import { Link } from "react-router-dom";
import classNames from "classnames";
import { LoadableComponent } from "@loadable/component";
import { IMenuItem } from "../routes";
import useUser from "../hooks/UseUser";

interface ISideMenuProps {
  mobile?: boolean;
  top?: JSX.Element;
}

export const SideMenu: React.FC<ISideMenuProps> = (props) => {
  const navCtx = useNavigation();
  const userCtx = useUser();
  const rightsCtx = useRights();
  const preload = React.useCallback((route: IMenuItem) => {
    route.component &&
      (route.component as LoadableComponent<any>).preload &&
      (route.component as LoadableComponent<any>).preload();
  }, []);
  return (
    <Accordion
      as={Menu}
      vertical
      className={classNames("side-menu", { mobile: props.mobile })}
    >
      {props.top}
      {navCtx.routes
        .filter(
          (r) =>
            !r.accessRight ||
            r.accessRight.some((right) => rightsCtx.hasRight(right))
        )
        .map((route, i) => (
          <Menu.Item className="route-item" key={route.name}>
            {/* Control logic for External Links and Internal Links (Implemented as a part of Change Request - Search) */}
            <Accordion.Title
              className="item"
              as={route.url ? "a" : Link} //Use <a> for external links or else use internal navigation of myCISV
              href={route.url || undefined}  // This property is used for external links and represents the hyperlink
              target={route.url ? "_blank" : undefined} // This property will enable the external link to open on a new tab
              rel={route.url ? "noopener noreferrer" : undefined}  // This property for security purposes to avoid external links conflicting with CISV Site 
              onMouseEnter={() => preload(route)}
              icon={route.icon}
              to={route.url ? undefined : route.path} //to property will be used for internal routes only
              active={route.active}
              content={route.name}
              index={i}
            />
            <Accordion.Content
              as={Menu.Menu}
              active={route.active}
              content={
                route.submenu &&
                renderMenu(
                  route.submenu,
                  window.location.pathname,
                  rightsCtx.hasRight,
                  preload
                )
              }
            />
          </Menu.Item>
        ))}
      {props.mobile && (
        <Menu.Item className="route-item" onClick={() => userCtx.logout()}>
          <Accordion.Title
            className="item"
            content="Sign out"
            icon="sign-out"
          />
        </Menu.Item>
      )}
    </Accordion>
  );
};
